import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "success-message",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    staticStyle: {
      "height": "100%"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VRow, {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c(VCard, {
    staticClass: "ma-3 pa-6",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('div', {
    class: _vm.$store.state.app.UiTheme ? 'invert' : '',
    style: _vm.getBG()
  }), _c(VCardText, {
    staticClass: "text-center"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$i18n_t('Common.ticketCreatedText')))]), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "to": _vm.homeLink
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.backToHome')))])], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };